"use strict";

exports.__esModule = true;
exports["default"] = exports.DEFAULT_QUALITY = exports.RESIZE_COVER = exports.RESIZE_FIT = void 0;

var _RESIZE;

var RESIZE_FIT = 'fit';
exports.RESIZE_FIT = RESIZE_FIT;
var RESIZE_COVER = 'cover';
exports.RESIZE_COVER = RESIZE_COVER;
var DEFAULT_QUALITY = 80;
exports.DEFAULT_QUALITY = DEFAULT_QUALITY;
var DEFAULT_SIZE = 1000;
var RESIZE = (_RESIZE = {}, _RESIZE[RESIZE_COVER] = function (w, h, rw, rh) {
  if (rw > w || rh > h) {
    return {
      width: w,
      height: h
    };
  }

  var wRatio = rw / w;
  var hRatio = rh / h;
  var ratio = Math.max(wRatio, hRatio);
  return {
    width: Math.ceil(w * ratio),
    height: Math.ceil(h * ratio)
  };
}, _RESIZE[RESIZE_FIT] = function (w, h, rw, rh) {
  if (rw > w && rh > h) {
    return {
      width: w,
      height: h
    };
  }

  return {
    width: rw,
    height: rh
  };
}, _RESIZE); // eslint-disable-next-line max-params

var _default = function _default(_temp, rw, rh, quality, type) {
  var _ref = _temp === void 0 ? {} : _temp,
      fileName = _ref.file_name,
      w = _ref.width,
      h = _ref.height;

  if (rw === void 0) {
    rw = DEFAULT_SIZE;
  }

  if (rh === void 0) {
    rh = DEFAULT_SIZE;
  }

  if (quality === void 0) {
    quality = DEFAULT_QUALITY;
  }

  if (type === void 0) {
    type = RESIZE_FIT;
  }

  if (fileName) {
    var _RESIZE$type = RESIZE[type](w, h, rw, rh),
        width = _RESIZE$type.width,
        height = _RESIZE$type.height;

    return "https://static.wixstatic.com/media/" + fileName + "/v1/fit/w_" + width + ",h_" + height + ",al_c,q_" + quality + "/file.jpg"; // @todo: fix hardcoded url
  }

  return '';
};

exports["default"] = _default;